// lib
import React, { useEffect, useReducer, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tab,
  Tabs,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import equal from "fast-deep-equal";
// src
import PlanningList from "./partials/plannings/PlanningList";
import CategoryList from "./partials/categories/CategoryList";
import Alert from "../partials/Alert";
import { reducer, initState, createTree, serializeToPrefs } from "./state";

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return children;
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const Favorites = ({
  // data props
  favorites: savedFavorites,
  isFavoritesOpen,
  isSmall,
  // dispatch props
  hideFavorites,
  updateAndPatchFavorites,
}) => {
  const [state, dispatch] = useReducer(reducer, savedFavorites, initState);
  const { items, modified, prevFavorites } = state;
  const [tab, setTab] = useState(0);
  const [openCloseConfirm, setOpenCloseConfirm] = useState(false);
  const { t } = useTranslation();
  const tree = createTree(items);

  useEffect(() => {
    if (!equal(savedFavorites, prevFavorites)) {
      // reload on props update
      dispatch({ type: "init", payload: savedFavorites });
    }
  }, [savedFavorites, prevFavorites]);

  // UX
  const handleChangeTab = (event, newTab) => {
    dispatch({ type: "unedit-all", payload: savedFavorites });
    setTab(newTab);
  };

  const handleCloseWithoutSaving = () => {
    setOpenCloseConfirm(false);
    dispatch({ type: "reinit" });
    hideFavorites();
  };
  const handleCloseWish = () => {
    return modified ? setOpenCloseConfirm(true) : handleCloseWithoutSaving();
  };
  const handleCloseCancel = () => setOpenCloseConfirm(false);
  const handleCloseAndSave = () => {
    updateAndPatchFavorites(serializeToPrefs(state));
    hideFavorites();
  };

  return (
    <>
      <Dialog
        className="modal-favorites"
        fullScreen={isSmall}
        open={isFavoritesOpen}
        onClose={handleCloseWish}
      >
        <IconButton className="close" onClick={handleCloseWish}>
          <Close />
        </IconButton>
        <DialogTitle disableTypography>
          <h2>{t("menu.favorites")}</h2>
          <div className="tabs">
            <Tabs value={tab} onChange={handleChangeTab} textColor="primary">
              <Tab key="simple" label={t("favorites.manageSimple")} />
              <Tab key="category" label={t("favorites.manageCategory")} />
            </Tabs>
          </div>
        </DialogTitle>
        <DialogContent>
          <TabPanel value={tab} index={0}>
            <PlanningList tree={tree} dispatch={dispatch} />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <CategoryList items={items} dispatch={dispatch} />
          </TabPanel>
        </DialogContent>
        <DialogActions className="actions">
          <Button onClick={handleCloseWithoutSaving}>{t("actions.cancel")}</Button>
          <Button onClick={handleCloseAndSave} color="primary" autoFocus disabled={!modified}>
            {t("actions.save")}
          </Button>
        </DialogActions>
      </Dialog>
      <Alert
        open={openCloseConfirm}
        cancelLabel={t("actions.cancel")}
        confirmLabel={t("actions.close")}
        onConfirm={handleCloseWithoutSaving}
        onCancel={handleCloseCancel}
      >
        <p>{t("favorites.unsavedModifications")}</p>
      </Alert>
    </>
  );
};

Favorites.propTypes = {
  // data props
  favorites: PropTypes.array.isRequired,
  isFavoritesOpen: PropTypes.bool.isRequired,
  isSmall: PropTypes.bool.isRequired,
  // dispatch props
  hideFavorites: PropTypes.func.isRequired,
  updateAndPatchFavorites: PropTypes.func.isRequired,
};

export default Favorites;
